import sendMonitoringEvent from '@/modules/monitoring/sendEvent';

export default function sendAnalyticsErrorEvent(eventData, err) {
  sendMonitoringEvent({
    type: 'PLAUSIBLE_EVENT_ERROR',
    data: {
      pathname: window.location.pathname,
      search: window.location.search,
      eventData,
      errorInfo: {
        message: err.message,
        name: err.name,
      },
    },
    result: 'error',
  });
}
